// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"545ec11e","133":"930610e9","247":"2c66d6e1","345":"9571b6cc","557":"c4808b53","573":"9b5ebec0","617":"7d7c9096","705":"93fdc741","707":"97579334","763":"a8670f50"}[chunkId] + ".chunk.js";
};